import script from "./ArawerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArawerCard.vue?vue&type=script&setup=true&lang=js"

import "./ArawerCard.vue?vue&type=style&index=0&id=383429f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383429f0"]])

export default __exports__